import { handleAPIResponse, getAuthHeaders } from '@/utils/apiUtils';
import { MasterOptions, VoicesResponse } from '@/types/master';
import { InterviewLanguage } from '@/types/jobs';

const API_BASE_URL = `${process.env.NEXT_PUBLIC_API_URL}`;

export interface PreviewVoiceRequest {
  provider: 'google' | 'elevenlabs';
  voiceId: string;
  text?: string;
  language?: InterviewLanguage;
}

export interface PreviewVoiceData {
  audioContent: string;
  audioUrl: string;
  voice: {
    provider: string;
    name?: string;
    voice_id?: string;
    displayName?: string;
  };
}

export const masterApi = {
  getOptions: async () => {
    const response = await fetch(`${API_BASE_URL}/master/options`, {
      headers: getAuthHeaders(),
    });

    return handleAPIResponse<MasterOptions>(response);
  },
  getVoices: async () => {
    const response = await fetch(`${API_BASE_URL}/master/voices`, {
      headers: getAuthHeaders(),
    });

    return handleAPIResponse<VoicesResponse>(response);
  },
  previewVoice: async (params: PreviewVoiceRequest) => {
    const response = await fetch(`${API_BASE_URL}/master/voices/preview`, {
      method: 'POST',
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    });

    return handleAPIResponse<PreviewVoiceData>(response);
  },
};
